import styled from "styled-components";

export const StyledAuthorizationLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  
  @media screen and (max-width: 767px) {
     grid-template-columns: 1fr;
  }
`;